/* eslint-disable */
export default {".choices > *":"box-sizing:border-box"}
/* eslint-enable */
